import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../UserInfo";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import ShowError from "../AppServices";
import axios from "../api-axios";
import { criarContribuinteDs, criarPrescricaoDiatDs } from "../DataSources";
import PaginaToolbar from "../components/PaginaToolbar";
import { DataGrid, Column, Pager, Paging, FormItem, Editing } from "devextreme-react/data-grid";
import api from "../api-axios";
import { showReportDirect } from "../showReport";

export default class PrescricaoDiat extends React.Component {
  constructor(props) {
    super(props);

    this._grid = React.createRef();

    const dataHoraCorrente = new Date();

    this.state = {
      exercicio: dataHoraCorrente.getFullYear() - 6,
      incluirNaoTributarias: false,
      executando: false,
      stNaoTributaria: false,
      simulacao: true,
      dataPrescricao: dataHoraCorrente,
      _uiView: "lista"
    };

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.novaPrescricao = this.novaPrescricao.bind(this);
    this.mostrarSimulacao = this.mostrarSimulacao.bind(this);


    this.contribuinteDs = criarContribuinteDs();
    this.prescricaoDs = criarPrescricaoDiatDs();

    this.selectBoxOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  novaPrescricao() {
    this.setState({ _uiView: "form" });
  }

  mostrarSimulacao(e) {
    const data = e.row.data;
    if (!data.stSimulacao) {
      notify("Prescrição não possui previsão!", "warning");
      return;
    }

    api.get(`/diat/prescricao_previsoes/${UserInfo.getPrefeitura()}/${data.id}`)
      .then(resp => {
        showReportDirect(resp.data.rptStr);
      })
      .catch(error => {
        notify(error, "error");
      });


  }


  render() {
    if (this.state.executando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <br />
          <h3>Carregando... </h3>
          <br />
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <div style={{ display: this.state._uiView === "form" ? "block" : "none" }}>

            <form>
              <Form formData={this.state} colCount={4} labelLocation="top">
                <GroupItem
                  caption="PRESCRIÇÃO ANUAL DA DÍVIDA ATIVA"
                  colSpan={4}
                  colCount={4}
                >
                  <SimpleItem
                    colSpan={1}
                    dataField="exercicio"
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                  >
                    <Label text="Exercício" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField="dataPrescricao"
                    editorType="dxDateBox"
                    editorOptions={{ width: "100%", useMaskBehavior: true }}
                  >
                    <Label text="Data da Prescrição" />
                  </SimpleItem>

                  <SimpleItem
                    colSpan={1}
                    dataField={"stNaoTributaria"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.selectBoxOptions}
                    helpText={"Recomendamos preencher sempre com 'NÃO', pois geralmente são executadas!"}
                  >
                    <Label text="Incluir Não Tributárias" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"simulacao"} stNaoTributaria
                    editorType={"dxSelectBox"}
                    editorOptions={this.selectBoxOptions}
                  >
                    <Label text="Simulação" />
                  </SimpleItem>
                </GroupItem>
              </Form>
              <div style={{ marginTop: "10px" }}>
                <div style={{ display: "inline-block" }}>
                  <Button
                    width={120}
                    text={this.state.executando ? "Executando..." : "Executar"}
                    disabled={this.state.executando ? true : false}
                    type="success"
                    onClick={this.ok}
                  />
                </div>
                <div style={{ display: "inline-block", marginLeft: "10px" }}>
                  <Button text="Cancelar" onClick={this.cancel} />
                </div>
              </div>
            </form>
          </div>


          <div style={{ display: this.state._uiView === "lista" ? "block" : "none" }}>
            <PaginaToolbar titulo="Prescrições" novoCb={this.novaPrescricao} >
              <DataGrid
                ref={(grid) => (this._grid = grid)}
                dataSource={this.prescricaoDs}
                showBorders={true}
                rowAlternationEnabled={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                headerFilter={{ visible: false }}
                filterRow={{ visible: true }}
              >
                <Editing allowUpdating={false} allowDeleting={false} />

                <Column
                  type="buttons"
                  fixed={true}
                  fixedPosition={"left"}
                  buttons={[
                    {
                      hint: "Ver previsoes",
                      icon: "exportpdf",
                      onClick: this.mostrarSimulacao
                    }
                  ]}
                />

                <Column dataField={"id"} alignment={"center"} caption={"#"} width={100} sortIndex={0} sortOrder={"desc"} />
                <Column dataField={"dtCadastro"} dataType={"datetime"} caption={"Data"} alignment={"center"} width={150} />
                <Column dataField={"stSimulacao"} caption={"Simulação"} width={100} />
                <Column dataField={"usuario.nome"} caption={"Usuário"} />
                <Column dataField={"status"} caption={"Status"} />
                <Column dataField={"statusDetalhe"} caption={"Andamento"} />


                <Column dataField={"msgErro"} caption={"Erro"} visible={false} />
                <Column dataField={"stackTrace"} caption={"StackTrace"} visible={false} />

                <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                />
              </DataGrid>
            </PaginaToolbar>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    this.setState({ executando: true });

    const state = this.state;

    const request = {
      prefeituraId: UserInfo.getPrefeitura(),
      exerciciosStr: state.exercicio.toString(),
      dataPrescricao: state.dataPrescricao,
      stNaoTributaria: state.stNaoTributaria,
      simulacao: state.simulacao
    };

    axios
      .post(`/diat/prescricao`, request)
      .then(_ => {
        notify("Procedimento agendado com sucesso.", "success");
        if (this._grid && this._grid.current) {
          this._grid.current.refres();
        }

        this.setState({
          executando: false,
          _uiView: "lista"
        });
      })
      .catch((error) => {
        console.log("error", error);
        if (error.response && error.response.data) {
          ShowError(error.response.data);
          notify(error.response.data, "error", 2000);
        } else {
          notify("Erro ao preescrever dívida ativa.", "error");
        }
      })
      .finally(() => {
        this.setState({ executando: false });
      });
  }

  cancel() {
    this.setState({ _uiView: "lista" });
  }
}
